import type { SvelteComponent } from 'svelte';
import { writable, type Writable } from 'svelte/store';

interface LoadedComponents {
  [key: string]: typeof SvelteComponent;
}

export { videoControl } from './instreamAdControlStore';
export {
  isToastVisible,
  resetToastStore,
  toastHeading,
  toastRedirectURL,
  toastSize,
  toastStoreController,
  toastVarient
} from './toastStore';
export const isTamEnabledInStore = writable<boolean>(false);
export const topNewsKeys = writable<Record<string, { headline: string }>>();
export const closeCookieModal = writable<boolean>(false);
export const navigateWithinSiteStore = writable({ fromInternal: false });
export const loadedComponents: Writable<LoadedComponents> = writable({});
export const scrollPositionsStore = writable<{ sectionName: string; position: number }>({
  sectionName: '',
  position: 0
});
export const isInterscrollerAdFilled = writable<boolean>(false);
export const isInterscrollerAdVisible = writable<boolean>(false);
export const selectedAgeGroupStore = writable<string>('');
export const adPrivacySettings = writable<{
  nonPersonalizedAds?: boolean;
  childDirectedTreatment?: boolean;
}>({
  nonPersonalizedAds: false,
  childDirectedTreatment: false
});
export const modalStore = writable({
  isOpen: false
});
export const redirectUrlStore = writable<string>('');
